var map = {
	"./Email.svg": 618,
	"./email-icon-hover.svg": 619,
	"./email-icon-hover_1.svg": 620,
	"./email-icon.svg": 621,
	"./email-icon_1.svg": 622,
	"./facebook-1.svg": 623,
	"./facebook-icon-2.svg": 624,
	"./facebook-icon-hover-2.svg": 625,
	"./facebook-icon-hover.svg": 626,
	"./twitter-1.svg": 627,
	"./twitter-icon-2.svg": 628,
	"./twitter-icon-hover-2.svg": 629,
	"./twitter-icon-hover.svg": 630
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 104;